var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { h, Fragment } from 'preact';
import { useState } from 'preact/hooks';
import { addVariantToShopifyThemeCart } from '../../utils/shopifyThemeCart';
import styles from './QuickShopModal.module.scss';
export function QuickShopModal({ product, onClose, selectedColor }) {
    var _a;
    const [selectedSize, setSelectedSize] = useState(null);
    const [selectedVariantId, setSelectedVariantId] = useState(null);
    const [isAdding, setIsAdding] = useState(false);
    // Get size options from variants, filtered by selected color if provided
    const sizes = (product.variants || [])
        .filter(variant => {
        var _a;
        if (!selectedColor)
            return true;
        const colorOption = (_a = variant.merged_options) === null || _a === void 0 ? void 0 : _a.find((opt) => opt.startsWith('colour:') || opt.startsWith('color:'));
        const variantColor = colorOption === null || colorOption === void 0 ? void 0 : colorOption.split(':')[1];
        return (variantColor === null || variantColor === void 0 ? void 0 : variantColor.toLowerCase()) === selectedColor.toLowerCase();
    })
        .map(variant => {
        var _a;
        const sizeOption = (_a = variant.merged_options) === null || _a === void 0 ? void 0 : _a.find((opt) => opt.startsWith('size:'));
        const size = (sizeOption === null || sizeOption === void 0 ? void 0 : sizeOption.split(':')[1]) || '';
        return {
            size,
            available: variant.available,
            variantId: variant.id,
        };
    });
    const handleSizeSelect = (size, variantId) => {
        setSelectedSize(size);
        setSelectedVariantId(variantId);
    };
    const handleAddToBag = () => __awaiter(this, void 0, void 0, function* () {
        if (!selectedVariantId)
            return;
        setIsAdding(true);
        try {
            yield addVariantToShopifyThemeCart(selectedVariantId);
            onClose();
        }
        catch (err) {
            console.error('Add to cart error:', err);
        }
        finally {
            setIsAdding(false);
        }
    });
    return (h("div", { class: styles.modalOverlay, onClick: onClose },
        h("div", { class: styles.modalContent, onClick: (e) => e.stopPropagation() },
            h("div", { class: styles.modalHeader },
                h("div", null,
                    h("h2", { class: styles.productTitle }, product.title),
                    h("div", { class: styles.priceSection }, product.compare_at_price_min && product.compare_at_price_min > product.price_min ? (h(Fragment, null,
                        h("span", { class: styles.salePrice },
                            "$",
                            product.price_min),
                        h("span", { class: styles.regularPrice },
                            "$",
                            product.compare_at_price_min),
                        product.percent_sale_min && (h("span", { class: styles.discountBadge },
                            "-",
                            product.percent_sale_min,
                            "%")))) : (h("span", { class: styles.price },
                        "$",
                        product.price_min)))),
                h("button", { class: styles.closeButton, onClick: onClose },
                    h("svg", { width: "13", height: "13", viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        h("path", { d: "M1.418 12.864L0 11.446L5.03067 6.41533L0 1.418L1.418 0L6.44867 5.03067L11.446 0L12.864 1.418L7.83333 6.41533L12.864 11.446L11.446 12.864L6.44867 7.83333L1.418 12.864Z", fill: "#474747" })))),
            h("div", { class: styles.imageSection }, product.images_info && product.images_info.length > 0 ? (product.images_info.map((img, index) => (h("img", { key: img.id, src: img.src, alt: `${product.title} ${index + 1}`, class: styles.productImage })))) : (h("img", { src: (_a = product.images) === null || _a === void 0 ? void 0 : _a['1'], alt: product.title, class: styles.productImage }))),
            h("div", { class: styles.modalFooter },
                h("div", { class: styles.sizeSection },
                    h("div", { class: styles.sizeGrid }, sizes.map(({ size, available, variantId }) => (h("button", { key: variantId, class: `${styles.sizeButton} ${selectedSize === size ? styles.selectedSize : ''} ${!available ? styles.unavailableSize : ''}`, onClick: () => available && handleSizeSelect(size, variantId), disabled: !available }, size))))),
                h("button", { class: styles.addToBagButton, onClick: handleAddToBag, disabled: !selectedSize || isAdding }, isAdding ? 'ADDING...' : selectedSize ? 'ADD TO BAG' : 'NOTIFY ME'),
                h("a", { href: `/products/${product.handle}`, class: styles.viewFullDetails }, "VIEW PRODUCT DETAILS \u2192")))));
}
